// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_JSDate from "../Data.JSDate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Unscramble from "../Unscramble/index.js";
var TZLabel = function (x) {
    return x;
};
var LocalDateTime = /* #__PURE__ */ (function () {
    function LocalDateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LocalDateTime.create = function (value0) {
        return function (value1) {
            return new LocalDateTime(value0, value1);
        };
    };
    return LocalDateTime;
})();
var showTZLabel = Data_Show.showString;
var showLocalDateTime = {
    show: function (v) {
        return DateUtils.formatISODate(v.value0) + (" " + DateUtils.formatISOTime(v.value1));
    }
};
var parseTZLabel = function (str) {
    var $18 = $foreign.zoneExists(str);
    if ($18) {
        return new Data_Maybe.Just(str);
    };
    return Data_Maybe.Nothing.value;
};
var udecodeTZLabel = {
    unsafeDecode: function (f) {
        var str = Unscramble.decodeString(f);
        var v = parseTZLabel(str);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Unscramble.decodingError("Invalid time zone: " + Data_Show.show(Data_Show.showString)(str));
        };
        throw new Error("Failed pattern match at Data.Time.Local (line 54, column 7 - line 56, column 71): " + [ v.constructor.name ]);
    }
};
var unsafeParseTZLabel = function (str) {
    var v = parseTZLabel(str);
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Partial_Unsafe.unsafeCrashWith("unsafeParseTZLabel: Invalid TZLabel: " + Data_Show.show(Data_Show.showString)(str));
    };
    throw new Error("Failed pattern match at Data.Time.Local (line 73, column 3 - line 75, column 85): " + [ v.constructor.name ]);
};
var utc = /* #__PURE__ */ unsafeParseTZLabel("UTC");
var localTime = function (v) {
    return v.value1;
};
var localDate = function (v) {
    return v.value0;
};
var fromZeroBasedMonthIndex = /* #__PURE__ */ (function () {
    var $41 = Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth);
    return function ($42) {
        return $41((function (v) {
            return Data_Numeric.add(Data_Numeric.additiveInt)(v)(1);
        })($42));
    };
})();
var fromTimeComponents = function (x) {
    return Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Time.Time.create)(Data_Enum.toEnum(Data_Time_Component.boundedEnumHour)(x.hours)))(Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute)(x.minutes)))(Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond)(x.seconds)))(Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond)(x.milliseconds));
};
var fromDateTimeUTC = function (dt) {
    return Data_JSDate.fromDateTime(dt);
};
var fromDateComponents = function (x) {
    return Control_Bind.join(Data_Maybe.bindMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Date.exactDate)(Data_Enum.toEnum(Data_Date_Component.boundedEnumYear)(x.year)))(fromZeroBasedMonthIndex(x.month)))(Data_Enum.toEnum(Data_Date_Component.boundedEnumDay)(x.day)));
};
var fromDateTimeComponents = function (x) {
    return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(LocalDateTime.create)(fromDateComponents(x)))(fromTimeComponents(x));
};
var fromJSDateLocal = function (jsDate) {
    return fromDateTimeComponents($foreign.getJSDateComponentsLocal(jsDate));
};
var utcToLocalDateTime = function (dt) {
    return function (tz) {
        var jsDate = fromDateTimeUTC(dt);
        var local = $foreign.utcToZonedTime(jsDate, tz);
        var v = fromJSDateLocal(local);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Partial_Unsafe.unsafeCrashWith("utcToLocalDateTime(" + (Data_Show.show(Data_DateTime.showDateTime)(dt) + (", " + (Data_Show.show(showTZLabel)(tz) + ("): returned invalid datetime: " + Effect_Unsafe.unsafePerformEffect(Data_JSDate.toISOString(local)))))));
        };
        throw new Error("Failed pattern match at Data.Time.Local (line 100, column 5 - line 105, column 60): " + [ v.constructor.name ]);
    };
};
var utcToLocalDateTime$prime = function (v) {
    return utcToLocalDateTime(v);
};
var localNow = function (dictMonadEffect) {
    return function (tz) {
        return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Data_UTCTime.now(dictMonadEffect))(function (now) {
            return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(utcToLocalDateTime$prime(now)(tz));
        });
    };
};
var eqTZLabel = Data_Eq.eqString;
var eqLocalDateTime = {
    eq: function (v) {
        return function (v1) {
            return Data_Eq.eq(Data_Date.eqDate)(v.value0)(v1.value0) && Data_Eq.eq(Data_Time.eqTime)(v.value1)(v1.value1);
        };
    }
};
var encodeTZLabel = {
    encode: function (v) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v);
    }
};
var decodeTZLabel = {
    decode: function (f) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(f))(function (str) {
            var v = parseTZLabel(str);
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Invalid time zone: " + Data_Show.show(Data_Show.showString)(str)));
            };
            throw new Error("Failed pattern match at Data.Time.Local (line 45, column 5 - line 47, column 73): " + [ v.constructor.name ]);
        });
    }
};
export {
    TZLabel,
    utc,
    parseTZLabel,
    unsafeParseTZLabel,
    LocalDateTime,
    localDate,
    localTime,
    utcToLocalDateTime,
    utcToLocalDateTime$prime,
    localNow,
    eqTZLabel,
    showTZLabel,
    decodeTZLabel,
    udecodeTZLabel,
    encodeTZLabel,
    showLocalDateTime,
    eqLocalDateTime
};
//# sourceMappingURL=index.js.map
